module.exports = __webpack_public_path__ + "static/media/Bolivia.68a36905.svg";